import { render, staticRenderFns } from "./ConsumerUsers.vue?vue&type=template&id=68ae28e8&scoped=true&"
import script from "./ConsumerUsers.vue?vue&type=script&lang=js&"
export * from "./ConsumerUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ae28e8",
  null
  
)

export default component.exports